var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13114_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2017 10.5812C27.232 8.6875 30.1028 5.66458 31.2528 2.78125C31.786 1.44583 30.7155 0 29.2727 0H16.7273C15.2845 0 14.214 1.44375 14.7472 2.78125C15.8972 5.66458 18.768 8.6875 20.7983 10.5812C9.55336 12.2458 0 26.2875 0 37.5C0 44.3937 5.62664 50 12.5455 50H33.4545C40.3734 50 46 44.3937 46 37.5C46 26.2875 36.4466 12.2458 25.2017 10.5812Z",
    fill: "#7A9FF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13114_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBag);
export default __webpack_public_path__ + "static/media/blue-bag.8608c758d010526e5c93668daa9feffc.svg";
export { ForwardRef as ReactComponent };